import React from 'react';
import CharacterCounter from "../../../../Components/Inputs/CharacterCounter";
import OptionalFormRow
    from "../../../../Components/HorizontalForm/OptionalFormRow";
import VisitorList from "../Groups/VisitorList";
import {defaultVisitor} from "../Groups/VisitorFormGroup";
import OptionalFormSection
    from "../../../../Components/HorizontalForm/OptionalFormSection";

const BookingFormVisitors = (props) => {

    const handleChange = (name, value) => {
        props.onChange(name, value);
    }

    const handleChangeEvent = (event) => {
        props.onChange(event.target.name, event.target.value);
    }

    const handleAddVisitor = () => {
        props.onChange('visitors', [...props.values.visitors, {...defaultVisitor}]);
    }

    const handleDeleteVisitor = (index) => {
        let localVisitors = [
            ...props.values.visitors.slice(0, index),
            ...props.values.visitors.slice(index + 1)
        ];

        props.onChange('visitors', localVisitors);
    }

    const handleUpdateVisitor = (name, value, index) => {
        let localVisitors = [ ...props.values.visitors ];
        localVisitors[index][name] = value;
        props.onChange('visitors', localVisitors);
    }

    const handleInviteVisitorsExpandedChange =  (expanded) => {

        if (expanded && !props.values.visitors.length) {
            // Add a blank visitor if we're expanding the invite visitors section for the first time
            handleAddVisitor();
        } else if (props.values.visitors.length) {
            // Remove any previously added visitors if we're collapsing the invite visitors section
            props.onChange('visitors', []);
            props.onChange('visitors_notes', '');
        }

        handleChange('visitors_added', expanded)
    }

    if (!props.bookingConfig?.visitors_enabled) {
        return null;
    }

    return <>
        <OptionalFormSection
            title="Invite Visitors"
            tooltip="Adding visitors to your booking will also create a visitor booking on the visitor management system at the same date and time"
            isExpanded={props.values.visitors_added}
            onExpanded={handleInviteVisitorsExpandedChange}
        >
            <OptionalFormRow
                label="Notes for reception"
                value={props.values.visitors_notes}
                onHide={() => handleChange('visitors_notes', '')}
                errorMessage={props.errors.visitors_notes}
                collapsible
            >
                <CharacterCounter
                    max={255}
                    value={props.values.visitors_notes}
                    onChange={handleChangeEvent}
                    errorMessage={props.errors.visitors_notes}
                >
                    <textarea
                        name="visitors_notes"
                        value={props.values.visitors_notes}
                        onChange={handleChangeEvent}
                        rows={4}
                        style={{ resize: 'none' }}
                    />
                </CharacterCounter>
            </OptionalFormRow>

            <VisitorList
                visitors={props.values.visitors}
                errors={props.errors}
                onAdd={handleAddVisitor}
                onDelete={handleDeleteVisitor}
                onUpdate={handleUpdateVisitor}
            />
        </OptionalFormSection>
    </>;
}

BookingFormVisitors.propTypes = {
}

BookingFormVisitors.defaultProps = {

}

export default BookingFormVisitors;
